import IntegrationCallModelBase from '../_generated/modelBases/integration-call-model-base';

export default class IntegrationCallModel extends IntegrationCallModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
